import { Controller } from "@hotwired/stimulus"

// Intercepts disabling "Add to expirations" on a persisted Date field. The
// checkbox is kept checked (so autosave never persists the change) until the
// user picks, in the confirmation modal, whether existing expirations created
// by this field should be removed. The choice and the disable are then
// submitted together, which is what the backend cleanup trigger expects.
export default class extends Controller {
  static targets = ["checkbox", "removeInput"]
  static values = { confirmationUrl: String, fieldId: String }

  confirmDisable(event) {
    if (this.applyingChoice) return

    // A real uncheck fires input then change; the input handler reverts the
    // checkbox, so the paired change must be swallowed by flag, not by state.
    if (this.suppressPairedChange && event.type === "change") {
      this.suppressPairedChange = false
      event.stopPropagation()
      return
    }

    if (this.checkboxTarget.checked) return

    event.stopPropagation()
    this.checkboxTarget.checked = true
    this.suppressPairedChange = event.type === "input"

    const frame = document.getElementById("modal")
    if (frame) frame.src = this.confirmationUrlValue
  }

  // The event is global, so a properties frame swapped in while the modal was
  // open must not consume a choice made for a different field.
  applyChoice(event) {
    if (event.detail.fieldId !== this.fieldIdValue) return

    this.removeInputTarget.value = event.detail.remove
    this.checkboxTarget.checked = false

    this.applyingChoice = true
    this.checkboxTarget.dispatchEvent(new Event("change", { bubbles: true }))
    this.applyingChoice = false
  }
}
